import React from "react";

const AddressCard  = (props)=>{
    let address = props.address;
    return(
       <div>

           <div>
               <h5>{address.firstname + " " + address.lastname}</h5>
           </div>
               <span className="text-left">

               <p className="pl-2">
                    {address.streetaddress}
               </p>
               <p className="pl-2">
                   Phone: {address.phone} 
               </p>
               </span>
              <button className="btn btn-sm btn-custom  m-2 btn-lg" style={{width:"90%"}}
                onClick={()=>props.handleDeliverToAddress(address)}
              >Deliver to this address</button>
         
           <div className="d-flex" style={{justifyContent:"center"}}>
                <button className="btn btn-sm btn-primary mr-3 bg-secondary" style={{flex:1}}
                     onClick={()=>props.handleEdit(address)}
                >Edit</button>
                <button className="btn btn-sm btn-primary ml-2 bg-danger" style={{flex:1}}
                     onClick={()=>props.handleDelete(address)}
                     disabled={props.loading}
                >
                     {
                          props.loading?"Deleting":"Delete"
                     }
                
                </button>
           </div>

       </div>
    )
}

export default AddressCard